const DEVANAGARI = /[ऀ-ॿ]/;
/** Font family used for Devanagari; must be registered in both renderers. */
export const DEVANAGARI_FONT = 'NotoSansDevanagari';
export function containsDevanagari(text) {
    return DEVANAGARI.test(text);
}
/**
 * If any word is Devanagari, return the Devanagari font; otherwise the base
 * family. Keeps a single decision point for script-aware fonts.
 */
export function fontForWords(words, baseFamily) {
    return words.some((w) => containsDevanagari(w.text)) ? DEVANAGARI_FONT : baseFamily;
}
//# sourceMappingURL=scripts.js.map